'use client';

import { useEffect, useState } from 'react';

import { STATES_MAP } from '@ria-client/supergraph/marketplace/constants';
import type { StateAbbreviation } from '@ria-client/supergraph/marketplace/types';

import { getSafeRegionCodeFromClientCookies } from './geo-data';

export interface BankingReviewsEyebrowProps {
  stateForEyebrow?: StateAbbreviation;
}

// 12px/18px/0.8125px: packages/ui/src/Theme/index.ts:1041-1046 accentSmall variant.
const EYEBROW_CLASS_NAME =
  'mb-2 font-sans text-xs leading-normal font-bold uppercase tracking-[0.8125px] text-accent-foreground';

export function BankingReviewsEyebrow({ stateForEyebrow }: BankingReviewsEyebrowProps) {
  const [updatedEyebrow, setUpdatedEyebrow] = useState('Editorial Review');

  useEffect(() => {
    const regionCodeToUse = getSafeRegionCodeFromClientCookies() ?? stateForEyebrow;
    if (regionCodeToUse) {
      // Cookie state is only available after client hydration.
      // eslint-disable-next-line react-hooks/set-state-in-effect -- synchronizes client cookie state.
      setUpdatedEyebrow(`Editorial Review - ${STATES_MAP[regionCodeToUse]}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- preserves the legacy mount-time prop fallback.
  }, []);

  if (!stateForEyebrow) return null;

  return <p className={EYEBROW_CLASS_NAME}>{updatedEyebrow}</p>;
}
